package es.subastia.ui.model

import subastia.composeapp.generated.resources.Res
import subastia.composeapp.generated.resources.option_others
import subastia.composeapp.generated.resources.option_properties
import subastia.composeapp.generated.resources.option_vehicles
import org.jetbrains.compose.resources.StringResource

enum class AuctionTypeUiModel(val id: String, val textRes: StringResource, val boeCode: String) {
    Inmuebles("inmuebles", Res.string.option_properties, "I"),
    Vehiculos("vehiculos", Res.string.option_vehicles, "V"),
    Otros("otros", Res.string.option_others, "M");
}
